
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124381409",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5717",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M446.00853333 193.42186667L291.27146667 11.37813333H116.05333333l154.73813334 182.04373334z m455.11146667 0L746.38186667 11.37813333H571.1648l154.73706667 182.04373334z m-227.5552 0L518.82666667 11.37813333H343.60853333L498.34666667 193.42186667z m293.54666667-182.04373334H798.72l154.73813333 182.04373334h81.92V79.6448c0-38.6848-29.58293333-68.26666667-68.26666666-68.26666667z m-903.39626667 0h-6.82666667c-38.68373333 0-68.26666667 29.58186667-68.26666666 68.26666667v113.77706667H218.45333333L63.7152 11.37813333z m-75.09333333 932.97706667c0 38.6848 29.58293333 68.26666667 68.26666666 68.26666667h910.22293334c38.68373333 0 68.26666667-29.58186667 68.26666666-68.26666667V238.93333333H-11.37813333v705.42186667zM352.71146667 443.73333333c0-38.6848 31.85706667-56.88853333 68.26666666-56.88853333 11.37706667 0 25.0304 2.2752 36.40853334 9.10186667L716.8 546.13333333c45.51146667 25.03146667 45.51146667 88.74666667 0 113.77813334l-259.41333333 150.18666666c-11.37813333 6.82666667-22.7552 9.10186667-36.40853334 9.10186667-36.4096 0-68.26666667-18.2048-68.26666666-56.88853333V443.73333333z",
        "p-id": "5718"
      }
    }
  ]
})
    }
  